export default "__VITE_ASSET__DBiECFRt__"